import {analytics} from '@cl/shared';
import {createAsyncThunk} from '@reduxjs/toolkit';
import analyticsApi from 'common/src/modules/analytics/analytics.api';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import _find from 'lodash/find';
import dashboardsApi from '../../dashboards.api';
import {DashboardPageState, DashboardWidget} from '../../dashboards.types';
import {updateDashboardPage, updateIsLoading} from '../dashboardPage.slice';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';

const {cachedAnalyticsSubject} = analytics;

export const loadDashboardPage = createAsyncThunk<DashboardWidget[] | void, {dashboardId: number}>(
  `${BreadcrumbName.Dashboard}/loadDashboardPage`,
  async ({dashboardId}, {dispatch}) => {
    try {
      dispatch(updateIsLoading(true));

      const dashboards = await dashboardsApi.getDashboards();

      const dashboard = _find(dashboards, {id: dashboardId});

      if (!dashboard) {
        return routingService.redirectTo(Routes.Dashboard);
      }

      const isCompatibilityGroupsEnabled = isFlagEnabled(
        FeatureFlagKey.EnableCompatibilityGroupsInAnalytics,
      );

      const widgets = await dashboardsApi.getWidgets(+dashboardId);

      const metricsAndDimensionsOptions = await analyticsApi.getOptionalMetricsAndDimensions(
        cachedAnalyticsSubject.data.hasMetaCustomConversions,
        isCompatibilityGroupsEnabled,
      );

      const filters = await analyticsApi.getOptionalDimensionsForFilters();
      const dashboardPage: Partial<DashboardPageState> = {
        dashboards,
        dashboardId,
        metricsAndDimensionsOptions,
        isLoading: false,
        filters,
      };

      dispatch(updateDashboardPage(dashboardPage));

      return widgets;
    } catch (error) {
      handleApiError(error);

      dispatch(updateIsLoading(false));

      return [];
    }
  },
);
